module.exports = __webpack_public_path__ + "img/9788997729838.db790d31.jpg";